import ActionTypes from '../constants/action-types';
import { RootActionTypes } from '../../../stores/types';

export default function changeDateRange(startDate: string, endDate: string): RootActionTypes {
  return {
    type: ActionTypes.CHANGE_DATE_RANGE,
    payload: { startDate, endDate },
  };
}
